import React from 'react';

import { ADMIN_TIME_OFF } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { WorkingPatternsIcon } from '@Generic/icons';
import { FEATURE_FLAG_WORKING_PATTERNS, FEATURE_FLAG_WORKING_PATTERNS_ADMIN } from '@ApplicationWide/feature-flags';

const AdminWorkingPatternsPage = React.lazy(() => import('../../../pages/Admin/WorkingPatterns'));

export default {
  label: 'admin-page.working-patterns.list.title',
  group: ADMIN,
  to: '/administration/working-patterns',
  route: '/administration/working-patterns',
  component: AdminWorkingPatternsPage,
  icon: <WorkingPatternsIcon />,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_TIME_OFF,
  area: ADMIN_TIME_OFF,
  featureFlag: [FEATURE_FLAG_WORKING_PATTERNS_ADMIN, FEATURE_FLAG_WORKING_PATTERNS],
  hasNavBar: true,
};
